import { render } from "./LoaderIcon.vue?vue&type=template&id=171460ae"
import script from "./LoaderIcon.vue?vue&type=script&lang=js"
export * from "./LoaderIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__